var React = require('react');

function ListInline (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"4.80005","y":"4.8","width":"22.4","height":"22.4","rx":"2","stroke":"#EC5344","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M9.59998 4.8H22.4L21.2558 8.23246C20.9836 9.04914 20.2193 9.6 19.3585 9.6H12.6415C11.7806 9.6 11.0164 9.04914 10.7441 8.23246L9.59998 4.8Z","stroke":"#EC5344","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M9.59998 16H22.4","stroke":"#EC5344","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":2}),React.createElement("path",{"d":"M10 21H22","stroke":"#EC5344","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":3})]);
}

ListInline.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = ListInline;

ListInline.default = ListInline;
